import {
  EstimationRecord,
  EstimationRecordsDef,
} from "../type/batch-def";

/** 数値でなければ null。`point_estimate` / `observed_value` は片方が null で来る。 */
function toNumber(value: unknown): number | null {
  const num = Number(value);
  return value != null && Number.isFinite(num) ? num : null;
}

export class EstimationRecordsAdapter {
  /**
   * 推定結果の行を画面用に正規化する。
   *
   * **予測値のある行だけ返す。** `source_only` の行は実測値（`observed_value`）
   * しか持たず、予測結果ではないので画面には出さない。
   * 並びは識別コード順で固定し、実行ごとに変わらないようにする。
   */
  static toOutputDTO(data: EstimationRecordsDef): EstimationRecord[] {
    const rows = (data?.items ?? []).map((item) => {
      // uploaded_only は推定値、source_only は実測値。両方入ることはない
      const estimate = toNumber(item.point_estimate);
      const observed = toNumber(item.observed_value);
      const isEstimated = estimate != null;

      return {
        id: item.record_id,
        identifierCode: item.identifier_code,
        presence: item.presence,
        isUploaded: item.presence === "uploaded_only",
        value: isEstimated ? estimate : observed,
        isEstimated,
        // 信頼区間が付くのは推定値のときだけ
        lower: isEstimated ? (item.uncertainty_interval?.lower ?? null) : null,
        upper: isEstimated ? (item.uncertainty_interval?.upper ?? null) : null,
      };
    });

    const estimated = rows.filter((row) => row.isEstimated);
    estimated.sort((a, b) =>
      a.identifierCode.localeCompare(b.identifierCode)
    );

    return estimated;
  }
}
